// Parent account deletion (MC2 card 072cd5b4; contract in the shared
// DELETION-SPEC: POST /delete-account { password }).

export const DELETE_ACCOUNT_PATH = "/delete-account";

// Refusals the delete page explains itself. The app's response interceptor
// (AppWrapper) treats every 401/403 as an ended session and signs the browser
// out, but a wrong password (401 WRONG_PASSWORD) or an organiser account
// (403 NOT_SELF_SERVICE) on this one request must stay on the page with the
// server's message. A bad or expired token carries no code, so it still
// signs out as before.
const PAGE_HANDLED_CODES = ["WRONG_PASSWORD", "NOT_SELF_SERVICE"];

export const isDeleteAccountRefusal = (error) => {
  const url = String(error?.config?.url || "");
  const path = url.split("?")[0].replace(/\/+$/, "");
  if (!path.endsWith(DELETE_ACCOUNT_PATH)) return false;
  return PAGE_HANDLED_CODES.includes(error?.response?.data?.code);
};

// Signed out on /delete-account: log in, then come back here. Uses the parent
// login's existing return-path keys (Parent/Auth/SignIn.jsx: redirectFromOrg +
// orgPath, as the AppWrapper "?type=redirect" links do).
export const rememberDeleteAccountReturn = (storage = window.localStorage) => {
  storage.setItem("orgPath", DELETE_ACCOUNT_PATH);
  storage.setItem("redirectFromOrg", "redirect");
};
